export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const IS_DEVELOPMENT = !IS_PRODUCTION;

// API Configuration
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
// Remove /api since it will be added by the axios client
export const API_BASE_URL = API_URL;

// File upload constraints
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const ALLOWED_FILE_TYPES = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png'];

// Feature flags
export const ENABLE_MOCK_API = process.env.REACT_APP_ENABLE_MOCK_API === 'true';
// Make sure this is set to true for analytics to work
export const ENABLE_ANALYTICS = process.env.NODE_ENV === 'production' || true;

// App configuration
export const APP_NAME = 'JobReferral';
export const DEFAULT_REDIRECT_DELAY = 2000; // 2 seconds

// reCAPTCHA configuration
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

// Helper function to get environment variables with type safety
const getEnvVar = (key: string): string | undefined => {
  return process.env[key];
};

// Export helper function at the end
export { getEnvVar };